/**
 * Build a browser URL for a file stored under /upload or /media.
 * REACT_APP_FILE_URL is empty on same-origin deploys. A stored link already
 * starts with "/", so prefixing another slash makes "//upload/..." which the
 * browser treats as a different host.
 */
export function publicFileUrl(filePath) {
  if (filePath == null || filePath === "") return "";
  const value = String(filePath).trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;

  const base = String(process.env.REACT_APP_FILE_URL || "").replace(/\/$/, "");
  const relative = value.startsWith("/") ? value : `/${value}`;
  return `${base}${relative}`;
}
